import { useNavigate } from "react-router-dom";
import { Plus, UserCheck, Package, FileText, Settings } from "lucide-react";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Button,
} from "@b2b/ui-components";

const quickActions = [
  {
    title: "Add Category",
    description: "Create new product category",
    icon: Plus,
    action: "add_category",
    path: "/admin/admin_categories",
  },
  {
    title: "Approve Seller",
    description: "Review pending seller applications",
    icon: UserCheck,
    action: "approve_seller",
    path: "/admin/admin_userlist",
    searchParams: "?status=pending",
  },
  {
    title: "Manage Products",
    description: "Review and moderate products",
    icon: Package,
    action: "manage_products",
    path: "/admin/admin_products",
  },
  {
    title: "Content Updates",
    description: "Update banners and sections on homepage",
    icon: FileText,
    action: "content_updates",
    path: "/admin/homepage",
  },
];

export function AdminQuickActions() {
  const navigate = useNavigate();

  const handleActionClick = (action: typeof quickActions[0]) => {
    const path = action.searchParams
      ? `${action.path}${action.searchParams}`
      : action.path;
    navigate(path);
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center space-x-2">
          <Settings className="h-5 w-5" />
          <span>Quick Actions</span>
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        {quickActions.map((action) => (
          <Button
            key={action.action}
            variant="outline"
            className="w-full justify-start h-auto p-4 hover:bg-orange-100 hover:border-orange-400"
            onClick={() => handleActionClick(action)}
          >
            <div className="flex items-center space-x-3 w-full">
              <div className="w-10 h-10 rounded-lg bg-orange-50 flex items-center justify-center">
                <action.icon className="h-5 w-5 text-orange-500" />
              </div>
              <div className="flex-1 text-left">
                <p className="font-medium text-sm">{action.title}</p>
                <p className="text-xs text-gray-500">{action.description}</p>
              </div>
            </div>
          </Button>
        ))}
      </CardContent>
    </Card>
  );
}
